export const setCreatedSensor = (pageRefresh) => {
  return {
    type: 'SET_CREATED_SENSOR',
    sensorPageRefresh: pageRefresh
  }
}